import get from "lodash/get";
import {useFormContext} from "react-hook-form";

import {SelectField, SelectFieldBaseProps} from "@/components/form/fields/SelectField/SelectField.tsx";
import {IncidentStateSelect} from "@/pages/incidents/components/incident-edit/components/updates/IncidentStateSelect/IncidentStateSelect.tsx";

export const IncidentStateSelectField = ({name, ...props}: SelectFieldBaseProps) => {
  const {
    watch,
    setValue,
    formState: {defaultValues},
    clearErrors,
  } = useFormContext();
  const defaultValue = get(defaultValues, watch(name));
  const value = watch(name);
  return (
    <SelectField
      name={name}
      {...props}
      select={
        <IncidentStateSelect
          defaultValue={defaultValue}
          value={value && {value: value}}
          onChange={(incidentValueOption) => {
            clearErrors(name);
            setValue(name, incidentValueOption?.value, {shouldDirty: true});
          }}
        />
      }
    />
  );
};
